(function () {
  var ROOT_SELECTOR = '[data-sa-industry-common-needs]';
  var BRAND_STORAGE_PREFIX = 'saIndustryBrand:';

  var INDUSTRY_TAG_BY_HANDLE = {
    'home-family-security': 'home-family',
    'elderly-carer-monitoring': 'elderly-carer',
    'shop-farm-and-rural-property-security-equipment': 'farms-rural-properties',
    'shop-warehouse-and-logistics-security-equipment': 'warehouses-logistics',
    'shop-construction-and-remote-surveillance-security-equipment': 'construction-remote-sites',
    'shop-retail-shops-storefront-security-equipment': 'retail-shopfronts',
    'traffic-control-temporary-sites': 'traffic-control-temporary',
    'shop-property-management-and-airbnb-security-equipment': 'airbnb-property-management',
    'shop-schools-and-private-colleges-security-equipment': 'schools-childcare',
    'shop-healthcare-security-equipment-for-practices-and-clinics': 'healthcare-clinics'
  };

  var COMMON_NEED_ALIASES = {
    'warehouse-loading-docks': 'loading-dock-monitoring',
    'loading-docks': 'loading-dock-monitoring',
    'loading-activity': 'loading-dock-monitoring',
    'warehouse-stockrooms': 'stock-protection',
    'stockrooms': 'stock-protection',
    'warehouse-perimeter': 'perimeter-protection',
    'after-hours-alerts': 'after-hours-monitoring',
    'after-hours-protection': 'after-hours-monitoring',
    'after-hours-deterrence': 'after-hours-monitoring',
    'stock-loss': 'stock-protection',
    'perimeter-awareness': 'perimeter-protection',
    'entry-monitoring': 'entrance-monitoring',
    'public-entrances': 'entrance-monitoring',
    'remote-property-viewing': 'remote-viewing',
    'external-property-monitoring': 'perimeter-protection',
    'perimeter-coverage': 'perimeter-protection',
    'remote-monitoring': 'remote-viewing'
  };

  var BRAND_DEFINITIONS = [
    { key: 'hikvision', label: 'Hikvision', terms: ['hikvision'] },
    { key: 'dahua', label: 'Dahua', terms: ['dahua'] },
    { key: 'axis', label: 'AXIS', terms: ['axis'] },
    { key: 'hanwha', label: 'Hanwha', terms: ['hanwha', 'hanwha vision', 'wisenet'] },
    { key: 'aiphone', label: 'Aiphone', terms: ['aiphone'] },
    { key: 'akuvox', label: 'Akuvox', terms: ['akuvox'] },
    { key: 'idis', label: 'IDIS', terms: ['idis'] },
    { key: 'hilook', label: 'HiLook', terms: ['hilook'] },
    { key: 'unv', label: 'UNV', terms: ['unv', 'uniview', 'uniarch'] },
    { key: 'tp-link-vigi', label: 'TP-Link / VIGI', terms: ['tp link', 'tp-link', 'vigi'] },
    { key: 'vivotek', label: 'Vivotek', terms: ['vivotek'] }
  ];

  var BASE_EXCLUDED_ROLES = {
    accessory: true,
    'accessory-component': true,
    'network-switch': true,
    storage: true,
    'software-licence': true,
    excluded: true,
    review: true,
    unresolved: true
  };

  var REASON_LABELS = {
    'role:ptz-camera': 'PTZ coverage',
    'role:bullet-camera': 'Directional camera',
    'role:turret-camera': 'Turret camera',
    'role:dome-camera': 'Dome camera',
    'role:camera': 'Camera',
    'role:complete-kit': 'Complete kit',
    'role:intercom-kit': 'Visitor access',
    'area:loading-docks': 'Loading dock fit',
    'area:driveway-perimeter': 'Driveway/perimeter',
    'area:car-parks-garages': 'Vehicle areas',
    'area:shop-floor-sales': 'Internal coverage',
    'area:front-door-entry': 'Entry monitoring',
    'area:reception-perimeter': 'Reception/entry',
    'concern:long-range-coverage': 'Long-range coverage',
    'concern:night-visibility': 'Night coverage',
    'concern:person-vehicle-detection': 'Person/vehicle detection',
    'concern:identification-detail': 'Identification detail',
    'concern:visitor-identification': 'Visitor identification',
    'concern:active-deterrence': 'Active deterrence',
    'concern:after-hours-monitoring': 'After-hours monitoring',
    'concern:remote-viewing': 'Remote viewing',
    'concern:wide-area-coverage': 'Wide-area coverage',
    'concern:wide-coverage': 'Wide coverage',
    'concern:gate-boundary-monitoring': 'Gate/boundary monitoring',
    'concern:entry-communication': 'Entry communication',
    'concern:discreet-monitoring': 'Discreet monitoring',
    'resolution:high': 'High resolution',
    'commercial:mainstream-commercial-fit': 'Mainstream brand fit',
    'commercial:value-price-fit': 'Commercial value',
    'commercial:complete-cctv-kit': 'Complete CCTV kit',
    'commercial:purpose-built-visitor-access': 'Purpose-built visitor access',
    'commercial:vehicle-flow-coverage': 'Vehicle flow coverage'
  };

  var COMPACT_REASON_LABELS = {
    'Person/vehicle detection': 'Person/vehicle',
    'Long-range coverage': 'Long range',
    'Night coverage': 'Night vision',
    'Driveway/perimeter': 'Perimeter',
    'Gate/boundary monitoring': 'Gate/boundary',
    'Wide-area coverage': 'Wide area',
    'Identification detail': 'Identification',
    'Directional camera': 'Directional',
    'Loading dock fit': 'Loading dock',
    'After-hours monitoring': 'After hours'
  };

  var PREMIUM_BRANDS = { axis: true, hanwha: true };
  var MAINSTREAM_BRANDS = { hikvision: true, dahua: true, hilook: true, unv: true, 'tp-link-vigi': true, aiphone: true, akuvox: true, idis: true };
  var GENERIC_REASON_TERMS = /^(explicitly mapped|mapped fit|matches taxonomy|destination match|in this destination|product image available)$/i;

  function profile(overrides) {
    var settings = Object.assign({
      threshold: 34,
      strongThreshold: 62,
      families: {},
      areas: {},
      concerns: {},
      blockedFamilies: {},
      diversity: { maxBrandInFirstFour: 2 },
      commercial: {}
    }, overrides || {});
    settings.diversity = Object.assign({ maxBrandInFirstFour: 2 }, settings.diversity || {});
    settings.commercial = Object.assign({
      allowPremium: true,
      premiumPenalty: 8,
      highPriceLimit: 3500,
      highPricePenalty: 18,
      maxPremiumInFirstFour: 1,
      maxHighPriceInFirstFour: 1,
      valuePriceCeiling: 2500,
      valueReward: 5,
      mainstreamBrandWeight: 3,
      completeSystemReward: 0,
      ptzSpecialistPenalty: 0,
      imageWeight: 6,
      missingImagePenalty: 10,
      firstFourFamily: '',
      firstFourFamilies: [],
      preferImageTopFour: true
    }, settings.commercial || {});
    return settings;
  }

  var GENERIC_PROFILE = profile({
    threshold: 30,
    strongThreshold: 58,
    families: { camera: 12, 'complete-kit': 12, 'ptz-camera': 14, 'turret-camera': 10, 'dome-camera': 10, 'bullet-camera': 12 },
    concerns: { 'remote-viewing': 5, 'night-visibility': 5, 'person-vehicle-detection': 5 }
  });

  var INDUSTRY_NEED_PROFILES = {
    'home-family-security': {
      'front-door-entry': profile({
        problem: 'Visitors, deliveries and household entry points.',
        allowIntercom: true,
        families: { 'intercom-kit': 22, 'turret-camera': 16, 'dome-camera': 12, camera: 10, 'complete-kit': 8 },
        areas: { 'front-door-entry': 24, 'reception-perimeter': 8 },
        concerns: { 'visitor-identification': 18, 'entry-communication': 14, 'remote-viewing': 10, 'night-visibility': 8, 'person-vehicle-detection': 7 }
      }),
      'driveway-perimeter': profile({
        problem: 'Vehicles, side gates and exposed approaches around the home.',
        families: { 'bullet-camera': 18, 'turret-camera': 16, 'complete-kit': 14, camera: 10, 'ptz-camera': 8 },
        areas: { 'driveway-perimeter': 24, 'front-door-entry': 8, 'car-parks-garages': 8 },
        concerns: { 'gate-boundary-monitoring': 16, 'person-vehicle-detection': 13, 'night-visibility': 12, 'remote-viewing': 8, 'active-deterrence': 7 }
      }),
      'family-property-monitoring': profile({
        problem: 'Shared household spaces, garages and everyday property visibility.',
        allowIntercom: true,
        families: { 'complete-kit': 18, 'turret-camera': 15, 'dome-camera': 14, camera: 10, 'intercom-kit': 8 },
        areas: { 'front-door-entry': 12, 'reception-perimeter': 10, 'shop-floor-sales': 6, 'driveway-perimeter': 6 },
        concerns: { 'remote-viewing': 18, 'wide-coverage': 10, 'visitor-identification': 9, 'night-visibility': 8, 'person-vehicle-detection': 7 }
      }),
      'night-monitoring': profile({
        problem: 'After-hours visibility around entrances and outdoor areas.',
        families: { 'complete-kit': 18, 'turret-camera': 16, 'bullet-camera': 16, camera: 10, 'ptz-camera': 8 },
        areas: { 'driveway-perimeter': 16, 'front-door-entry': 12, 'car-parks-garages': 8 },
        concerns: { 'night-visibility': 24, 'after-hours-monitoring': 16, 'remote-viewing': 10, 'active-deterrence': 9, 'person-vehicle-detection': 8 }
      }),
      'deterrence-alerts': profile({
        problem: 'Visible deterrence and practical alerts around exposed home areas.',
        threshold: 36,
        families: { 'complete-kit': 18, 'bullet-camera': 16, 'turret-camera': 14, camera: 10 },
        areas: { 'driveway-perimeter': 16, 'front-door-entry': 10 },
        concerns: { 'active-deterrence': 24, 'after-hours-monitoring': 16, 'night-visibility': 12, 'person-vehicle-detection': 9, 'remote-viewing': 8 }
      }),
      'remote-viewing': profile({
        problem: 'Checking home entrances, driveways and property areas while away.',
        allowIntercom: true,
        families: { 'complete-kit': 18, 'turret-camera': 14, 'dome-camera': 12, 'bullet-camera': 12, camera: 10, 'intercom-kit': 8 },
        areas: { 'front-door-entry': 12, 'driveway-perimeter': 12, 'reception-perimeter': 8 },
        concerns: { 'remote-viewing': 26, 'night-visibility': 10, 'visitor-identification': 9, 'person-vehicle-detection': 8 }
      })
    },
    'elderly-carer-monitoring': {
      'entry-visitor-monitoring': profile({
        problem: 'Practical entry visibility and visitor review for families and carers.',
        allowIntercom: true,
        families: { 'intercom-kit': 24, 'dome-camera': 14, 'turret-camera': 12, camera: 10, 'complete-kit': 6 },
        areas: { 'front-door-entry': 22, 'reception-perimeter': 14 },
        concerns: { 'visitor-identification': 18, 'entry-communication': 18, 'remote-viewing': 10, 'night-visibility': 6 }
      }),
      'remote-property-viewing': profile({
        problem: 'Remote security check-ins for key property areas between visits.',
        allowIntercom: true,
        families: { 'complete-kit': 18, 'turret-camera': 14, 'dome-camera': 12, camera: 10, 'intercom-kit': 8 },
        areas: { 'front-door-entry': 12, 'reception-perimeter': 10, 'driveway-perimeter': 8 },
        concerns: { 'remote-viewing': 26, 'visitor-identification': 10, 'night-visibility': 8, 'wide-coverage': 6 }
      }),
      'shared-area-visibility': profile({
        problem: 'Shared living areas, approaches and circulation spaces.',
        families: { 'dome-camera': 18, 'turret-camera': 14, camera: 10, 'complete-kit': 8 },
        areas: { 'reception-perimeter': 14, 'front-door-entry': 10, 'shop-floor-sales': 8 },
        concerns: { 'wide-coverage': 16, 'discreet-monitoring': 12, 'remote-viewing': 10, 'night-visibility': 6 },
        blockedFamilies: { 'ptz-camera': true }
      }),
      'simple-security-alerts': profile({
        problem: 'Straightforward alerts for entry and after-hours activity.',
        allowIntercom: true,
        families: { 'complete-kit': 18, 'intercom-kit': 14, 'turret-camera': 12, 'bullet-camera': 10, camera: 8 },
        areas: { 'front-door-entry': 14, 'driveway-perimeter': 10, 'reception-perimeter': 8 },
        concerns: { 'after-hours-monitoring': 18, 'remote-viewing': 14, 'entry-communication': 12, 'visitor-identification': 10, 'night-visibility': 8 }
      }),
      'intercom-communication': profile({
        problem: 'Entry communication and visitor access decisions.',
        allowIntercom: true,
        threshold: 36,
        strongThreshold: 64,
        families: { 'intercom-kit': 30, camera: 6, 'dome-camera': 6, 'turret-camera': 6 },
        areas: { 'front-door-entry': 20, 'reception-perimeter': 14 },
        concerns: { 'entry-communication': 26, 'visitor-identification': 14, 'remote-viewing': 8 }
      }),
      'external-property-monitoring': profile({
        problem: 'Driveways, side gates and outdoor approaches around the property.',
        families: { 'turret-camera': 16, 'bullet-camera': 16, 'complete-kit': 14, camera: 10, 'ptz-camera': 6 },
        areas: { 'driveway-perimeter': 20, 'front-door-entry': 10, 'car-parks-garages': 8 },
        concerns: { 'gate-boundary-monitoring': 14, 'night-visibility': 12, 'remote-viewing': 10, 'person-vehicle-detection': 8 }
      })
    },
    'shop-warehouse-and-logistics-security-equipment': {
      'loading-dock-monitoring': profile({
        problem: 'Vehicle arrivals, goods movement and dock approaches.',
        threshold: 42,
        strongThreshold: 70,
        families: { 'ptz-camera': 26, 'bullet-camera': 24, camera: 13, 'complete-kit': 10, 'turret-camera': 7, 'dome-camera': 3 },
        areas: { 'loading-docks': 30, 'driveway-perimeter': 12, 'car-parks-garages': 10 },
        concerns: { 'long-range-coverage': 18, 'identification-detail': 16, 'person-vehicle-detection': 13, 'night-visibility': 11, 'gate-boundary-monitoring': 8, 'wide-area-coverage': 8, 'remote-viewing': 4 },
        negativeRoles: { 'dome-camera': -3, 'complete-kit': -2 }
      }),
      'perimeter-protection': profile({
        problem: 'External walls, boundaries and exposed approaches.',
        threshold: 40,
        strongThreshold: 68,
        families: { 'bullet-camera': 24, 'ptz-camera': 22, 'turret-camera': 15, 'complete-kit': 14, camera: 10, 'dome-camera': 4 },
        areas: { 'driveway-perimeter': 24, 'loading-docks': 10, 'car-parks-garages': 10, 'front-door-entry': 6 },
        concerns: { 'gate-boundary-monitoring': 18, 'long-range-coverage': 16, 'night-visibility': 12, 'active-deterrence': 12, 'person-vehicle-detection': 10, 'wide-area-coverage': 8, 'remote-viewing': 4 }
      }),
      'stock-protection': profile({
        problem: 'High-value goods, storage aisles and restricted warehouse interiors.',
        threshold: 34,
        strongThreshold: 62,
        families: { 'dome-camera': 22, 'turret-camera': 20, camera: 14, 'complete-kit': 10, 'ptz-camera': 0, 'bullet-camera': 0 },
        areas: { 'shop-floor-sales': 14, 'reception-perimeter': 8, 'front-door-entry': 6, 'loading-docks': 4 },
        concerns: { 'wide-coverage': 14, 'wide-area-coverage': 10, 'discreet-monitoring': 12, 'person-vehicle-detection': 10, 'night-visibility': 8, 'remote-viewing': 5, 'identification-detail': 4 },
        blockedFamilies: { 'ptz-camera': true, 'bullet-camera': true }
      }),
      'vehicle-identification': profile({
        problem: 'Vehicle review around gates, yards and dispatch zones.',
        threshold: 42,
        strongThreshold: 72,
        families: { 'ptz-camera': 26, 'bullet-camera': 22, camera: 12, 'turret-camera': 8, 'complete-kit': 6, 'dome-camera': 4 },
        areas: { 'driveway-perimeter': 22, 'car-parks-garages': 18, 'loading-docks': 14, 'front-door-entry': 4 },
        concerns: { 'identification-detail': 22, 'visitor-identification': 12, 'long-range-coverage': 16, 'person-vehicle-detection': 9, 'night-visibility': 9, 'gate-boundary-monitoring': 8, 'remote-viewing': 3 },
        negativeRoles: { 'complete-kit': -5, 'dome-camera': -4 }
      }),
      'after-hours-monitoring': profile({
        problem: 'Overnight alerts, review and deterrence around yards and entries.',
        threshold: 38,
        strongThreshold: 66,
        families: { 'complete-kit': 20, 'turret-camera': 17, 'bullet-camera': 16, 'ptz-camera': 14, camera: 10, 'dome-camera': 4 },
        areas: { 'driveway-perimeter': 14, 'loading-docks': 12, 'car-parks-garages': 10, 'front-door-entry': 6 },
        concerns: { 'after-hours-monitoring': 22, 'active-deterrence': 18, 'night-visibility': 15, 'person-vehicle-detection': 12, 'remote-viewing': 9, 'gate-boundary-monitoring': 7, 'wide-area-coverage': 5 }
      })
    },
    'shop-retail-shops-storefront-security-equipment': {
      'entrance-monitoring': profile({ families: { 'dome-camera': 16, 'turret-camera': 14, camera: 12, 'intercom-kit': 8 }, areas: { 'front-door-entry': 20, 'reception-perimeter': 16 }, concerns: { 'visitor-identification': 15, 'remote-viewing': 8, 'night-visibility': 8 } }),
      'shop-floor-coverage': profile({ families: { 'dome-camera': 18, 'turret-camera': 16, camera: 12 }, areas: { 'shop-floor-sales': 24 }, concerns: { 'wide-coverage': 16, 'discreet-monitoring': 10, 'person-vehicle-detection': 8 } }),
      'checkout-pos-monitoring': profile({ families: { 'dome-camera': 18, 'turret-camera': 14, camera: 12 }, areas: { 'shop-floor-sales': 16, 'reception-perimeter': 8 }, concerns: { 'identification-detail': 18, 'visitor-identification': 10, 'discreet-monitoring': 8 } }),
      'stock-loss': profile({ families: { 'dome-camera': 18, 'turret-camera': 16, camera: 12 }, areas: { 'shop-floor-sales': 16 }, concerns: { 'discreet-monitoring': 12, 'person-vehicle-detection': 10, 'wide-coverage': 10, 'night-visibility': 7 } }),
      'after-hours-deterrence': profile({ families: { 'bullet-camera': 18, 'turret-camera': 16, 'complete-kit': 14, camera: 10 }, areas: { 'front-door-entry': 14, 'driveway-perimeter': 12 }, concerns: { 'active-deterrence': 20, 'after-hours-monitoring': 18, 'night-visibility': 14, 'remote-viewing': 8 } })
    },
    'shop-property-management-and-airbnb-security-equipment': {
      'entry-monitoring': profile({ allowIntercom: true, families: { 'intercom-kit': 18, 'dome-camera': 13, 'turret-camera': 12, camera: 10 }, areas: { 'front-door-entry': 22, 'reception-perimeter': 12 }, concerns: { 'entry-communication': 18, 'visitor-identification': 14, 'remote-viewing': 10 } }),
      'visitor-access': profile({ allowIntercom: true, families: { 'intercom-kit': 28, camera: 8, 'dome-camera': 8, 'turret-camera': 8 }, areas: { 'front-door-entry': 18, 'reception-perimeter': 14 }, concerns: { 'entry-communication': 24, 'visitor-identification': 14, 'remote-viewing': 8 } }),
      'remote-property-viewing': profile({ families: { 'complete-kit': 16, 'turret-camera': 14, 'dome-camera': 12, camera: 10 }, areas: { 'front-door-entry': 12, 'driveway-perimeter': 10 }, concerns: { 'remote-viewing': 22, 'night-visibility': 10, 'wide-coverage': 8 } }),
      'perimeter-awareness': profile({ families: { 'bullet-camera': 18, 'turret-camera': 16, 'complete-kit': 14, camera: 10 }, areas: { 'driveway-perimeter': 22, 'front-door-entry': 8 }, concerns: { 'gate-boundary-monitoring': 16, 'night-visibility': 12, 'person-vehicle-detection': 10 } }),
      'shared-area-coverage': profile({ families: { 'dome-camera': 18, 'turret-camera': 14, camera: 10 }, areas: { 'reception-perimeter': 14, 'shop-floor-sales': 8 }, concerns: { 'wide-coverage': 14, 'discreet-monitoring': 10, 'remote-viewing': 7 } })
    },
    'shop-schools-and-private-colleges-security-equipment': {
      'entrance-monitoring': profile({ allowIntercom: true, families: { 'dome-camera': 15, 'turret-camera': 14, camera: 12, 'intercom-kit': 12 }, areas: { 'front-door-entry': 18, 'reception-perimeter': 14 }, concerns: { 'visitor-identification': 14, 'remote-viewing': 8, 'person-vehicle-detection': 8 }, commercial: { allowPremium: false, premiumPenalty: 12, highPriceLimit: 3600, highPricePenalty: 18, maxPremiumInFirstFour: 1, maxHighPriceInFirstFour: 1, valuePriceCeiling: 2200, valueReward: 6, mainstreamBrandWeight: 5, imageWeight: 7, missingImagePenalty: 10 } }),
      'perimeter-awareness': profile({ families: { 'bullet-camera': 20, 'turret-camera': 18, 'complete-kit': 18, 'ptz-camera': 8, camera: 10 }, areas: { 'driveway-perimeter': 22, 'car-parks-garages': 12 }, concerns: { 'gate-boundary-monitoring': 16, 'night-visibility': 12, 'person-vehicle-detection': 10 }, commercial: { allowPremium: false, premiumPenalty: 14, highPriceLimit: 3600, highPricePenalty: 18, maxPremiumInFirstFour: 1, maxHighPriceInFirstFour: 1, valuePriceCeiling: 2400, valueReward: 6, mainstreamBrandWeight: 5, imageWeight: 7, missingImagePenalty: 10 } }),
      'pickup-drop-off-areas': profile({ threshold: 44, families: { 'complete-kit': 42, 'turret-camera': 30, 'bullet-camera': 28, camera: 16, 'ptz-camera': 8 }, areas: { 'car-parks-garages': 32, 'driveway-perimeter': 24, 'front-door-entry': 8 }, concerns: { 'person-vehicle-detection': 22, 'identification-detail': 12, 'night-visibility': 10, 'remote-viewing': 6 }, negativeRoles: { 'ptz-camera': -24, 'intercom-kit': -36, 'wide-area-camera': -8, 'dome-camera': -5 }, commercial: { allowPremium: false, premiumPenalty: 36, highPriceLimit: 3000, highPricePenalty: 42, maxPremiumInFirstFour: 0, maxHighPriceInFirstFour: 0, valuePriceCeiling: 2200, valueReward: 14, mainstreamBrandWeight: 8, completeSystemReward: 14, ptzSpecialistPenalty: 24, firstFourFamilies: ['complete-kit', 'turret-camera', 'bullet-camera', 'camera'], imageWeight: 10, missingImagePenalty: 14 } }),
      'visitor-management': profile({ threshold: 42, allowIntercom: true, families: { 'intercom-kit': 62, 'complete-kit': 2, 'dome-camera': 2, 'turret-camera': 2, camera: 2, 'bullet-camera': 0, 'ptz-camera': 0 }, areas: { 'front-door-entry': 28, 'reception-perimeter': 20 }, concerns: { 'entry-communication': 30, 'visitor-identification': 18, 'remote-viewing': 6 }, negativeRoles: { 'complete-kit': -42, camera: -28, 'dome-camera': -28, 'turret-camera': -28, 'bullet-camera': -30, 'ptz-camera': -36, 'wide-area-camera': -30 }, diversity: { maxBrandInFirstFour: 3 }, commercial: { allowPremium: false, premiumPenalty: 16, highPriceLimit: 1600, highPricePenalty: 18, maxPremiumInFirstFour: 0, maxHighPriceInFirstFour: 0, valuePriceCeiling: 500, valueReward: 14, mainstreamBrandWeight: 5, firstFourFamily: 'intercom-kit', imageWeight: 36, missingImagePenalty: 90 } }),
      'common-area-coverage': profile({ families: { 'dome-camera': 20, 'turret-camera': 18, 'complete-kit': 14, camera: 10, 'wide-area-camera': 10 }, areas: { 'shop-floor-sales': 10, 'reception-perimeter': 10, 'hallways-corridors': 10 }, concerns: { 'wide-coverage': 14, 'discreet-monitoring': 8, 'person-vehicle-detection': 7 }, commercial: { allowPremium: false, premiumPenalty: 12, highPriceLimit: 3600, highPricePenalty: 18, maxPremiumInFirstFour: 1, maxHighPriceInFirstFour: 1, valuePriceCeiling: 2400, valueReward: 6, mainstreamBrandWeight: 5, imageWeight: 7, missingImagePenalty: 10 } })
    },
    'shop-healthcare-security-equipment-for-practices-and-clinics': {
      'reception-monitoring': profile({ families: { 'dome-camera': 18, 'turret-camera': 14, camera: 10 }, areas: { 'reception-perimeter': 20, 'front-door-entry': 8 }, concerns: { 'visitor-identification': 14, 'discreet-monitoring': 10, 'remote-viewing': 6 } }),
      'public-entrances': profile({ allowIntercom: true, families: { 'dome-camera': 16, 'turret-camera': 14, camera: 10, 'intercom-kit': 8 }, areas: { 'front-door-entry': 20, 'reception-perimeter': 14 }, concerns: { 'visitor-identification': 14, 'entry-communication': 10, 'night-visibility': 6 } }),
      'perimeter-awareness': profile({ families: { 'bullet-camera': 16, 'turret-camera': 14, camera: 10 }, areas: { 'driveway-perimeter': 20, 'front-door-entry': 8 }, concerns: { 'gate-boundary-monitoring': 14, 'night-visibility': 10, 'remote-viewing': 8 } }),
      'visitor-access': profile({ allowIntercom: true, families: { 'intercom-kit': 24, 'dome-camera': 10, 'turret-camera': 8, camera: 8 }, areas: { 'front-door-entry': 18, 'reception-perimeter': 16 }, concerns: { 'entry-communication': 22, 'visitor-identification': 12 } }),
      'shared-area-coverage': profile({ families: { 'dome-camera': 18, 'turret-camera': 13, camera: 10 }, areas: { 'reception-perimeter': 12, 'shop-floor-sales': 8 }, concerns: { 'wide-coverage': 12, 'discreet-monitoring': 10, 'remote-viewing': 6 } })
    },
    'shop-farm-and-rural-property-security-equipment': {
      'gate-monitoring': profile({ families: { 'bullet-camera': 18, 'ptz-camera': 18, 'turret-camera': 12, camera: 10 }, areas: { 'driveway-perimeter': 18, 'loading-docks': 6 }, concerns: { 'gate-boundary-monitoring': 20, 'long-range-coverage': 16, 'night-visibility': 12, 'remote-viewing': 8 } }),
      'equipment-protection': profile({ families: { 'complete-kit': 18, 'bullet-camera': 16, 'turret-camera': 14, camera: 10 }, areas: { 'driveway-perimeter': 14, 'loading-docks': 8 }, concerns: { 'night-visibility': 14, 'person-vehicle-detection': 10, 'remote-viewing': 10, 'wide-area-coverage': 8 } }),
      'perimeter-protection': profile({ families: { 'bullet-camera': 18, 'ptz-camera': 16, 'turret-camera': 14, 'complete-kit': 12 }, areas: { 'driveway-perimeter': 22 }, concerns: { 'gate-boundary-monitoring': 16, 'long-range-coverage': 16, 'night-visibility': 12 } }),
      'remote-viewing': profile({ families: { 'complete-kit': 16, 'ptz-camera': 14, 'bullet-camera': 12, 'turret-camera': 12 }, areas: { 'driveway-perimeter': 12 }, concerns: { 'remote-viewing': 24, 'night-visibility': 10, 'wide-area-coverage': 8 } }),
      'after-hours-monitoring': profile({ families: { 'complete-kit': 18, 'bullet-camera': 16, 'turret-camera': 14, 'ptz-camera': 12 }, areas: { 'driveway-perimeter': 14 }, concerns: { 'after-hours-monitoring': 20, 'active-deterrence': 16, 'night-visibility': 15, 'remote-viewing': 8 } })
    },
    'shop-construction-and-remote-surveillance-security-equipment': {
      'site-perimeter': profile({ families: { 'bullet-camera': 18, 'ptz-camera': 16, 'turret-camera': 14, 'complete-kit': 12, camera: 10 }, areas: { 'driveway-perimeter': 22, 'large-outdoor-area': 14, 'loading-docks': 8 }, concerns: { 'gate-boundary-monitoring': 18, 'long-range-coverage': 15, 'night-visibility': 12, 'active-deterrence': 10, 'remote-viewing': 8 } }),
      'equipment-tool-protection': profile({ families: { 'complete-kit': 18, 'bullet-camera': 16, 'turret-camera': 14, camera: 10, 'ptz-camera': 8 }, areas: { 'driveway-perimeter': 16, 'loading-docks': 10, 'shop-floor-sales': 4 }, concerns: { 'after-hours-monitoring': 18, 'active-deterrence': 16, 'night-visibility': 14, 'remote-viewing': 10, 'person-vehicle-detection': 8 } }),
      'entry-gate-monitoring': profile({ families: { 'bullet-camera': 18, 'turret-camera': 14, 'ptz-camera': 14, camera: 10, 'complete-kit': 8 }, areas: { 'front-door-entry': 12, 'driveway-perimeter': 20, 'car-parks-garages': 8 }, concerns: { 'gate-boundary-monitoring': 20, 'visitor-identification': 10, 'person-vehicle-detection': 10, 'night-visibility': 8, 'remote-viewing': 6 } }),
      'temporary-site-coverage': profile({ families: { 'complete-kit': 18, 'ptz-camera': 16, 'bullet-camera': 14, 'turret-camera': 12, camera: 10 }, areas: { 'driveway-perimeter': 16, 'loading-docks': 10, 'car-parks-garages': 8 }, concerns: { 'wide-area-coverage': 16, 'remote-viewing': 14, 'night-visibility': 12, 'person-vehicle-detection': 8 } }),
      'after-hours-monitoring': profile({ families: { 'complete-kit': 18, 'bullet-camera': 16, 'turret-camera': 14, 'ptz-camera': 12, camera: 10 }, areas: { 'driveway-perimeter': 16, 'front-door-entry': 8, 'loading-docks': 8 }, concerns: { 'after-hours-monitoring': 22, 'active-deterrence': 18, 'night-visibility': 15, 'remote-viewing': 10, 'person-vehicle-detection': 8 } }),
      'remote-viewing': profile({ families: { 'complete-kit': 18, 'ptz-camera': 14, 'bullet-camera': 12, 'turret-camera': 12, camera: 10 }, areas: { 'driveway-perimeter': 14, 'loading-docks': 8 }, concerns: { 'remote-viewing': 26, 'wide-area-coverage': 10, 'night-visibility': 10, 'person-vehicle-detection': 7 } })
    },
    'traffic-control-temporary-sites': {
      'temporary-site-monitoring': profile({ families: { 'complete-kit': 18, 'ptz-camera': 16, 'bullet-camera': 14, 'turret-camera': 12, camera: 10 }, areas: { 'driveway-perimeter': 16, 'car-parks-garages': 12, 'loading-docks': 8 }, concerns: { 'remote-viewing': 18, 'wide-area-coverage': 14, 'night-visibility': 12, 'person-vehicle-detection': 9 } }),
      'equipment-protection': profile({ families: { 'complete-kit': 18, 'bullet-camera': 16, 'turret-camera': 14, camera: 10, 'ptz-camera': 8 }, areas: { 'driveway-perimeter': 16, 'loading-docks': 8 }, concerns: { 'after-hours-monitoring': 18, 'active-deterrence': 16, 'night-visibility': 14, 'remote-viewing': 10 } }),
      'vehicle-movement': profile({ families: { 'ptz-camera': 20, 'bullet-camera': 18, 'turret-camera': 12, camera: 10, 'complete-kit': 8 }, areas: { 'car-parks-garages': 22, 'driveway-perimeter': 18, 'loading-docks': 8 }, concerns: { 'person-vehicle-detection': 18, 'identification-detail': 14, 'wide-area-coverage': 10, 'remote-viewing': 6 } }),
      'site-entry': profile({ families: { 'bullet-camera': 18, 'turret-camera': 14, 'ptz-camera': 12, camera: 10, 'complete-kit': 8 }, areas: { 'front-door-entry': 12, 'driveway-perimeter': 20, 'car-parks-garages': 8 }, concerns: { 'gate-boundary-monitoring': 18, 'visitor-identification': 10, 'person-vehicle-detection': 9, 'night-visibility': 8 } }),
      'perimeter-coverage': profile({ families: { 'bullet-camera': 18, 'ptz-camera': 16, 'turret-camera': 14, 'complete-kit': 12, camera: 10 }, areas: { 'driveway-perimeter': 22, 'car-parks-garages': 10 }, concerns: { 'gate-boundary-monitoring': 16, 'long-range-coverage': 14, 'night-visibility': 12, 'wide-area-coverage': 10, 'active-deterrence': 8 } }),
      'remote-monitoring': profile({ families: { 'complete-kit': 18, 'ptz-camera': 14, 'bullet-camera': 12, 'turret-camera': 12, camera: 10 }, areas: { 'driveway-perimeter': 14, 'car-parks-garages': 8 }, concerns: { 'remote-viewing': 26, 'wide-area-coverage': 10, 'night-visibility': 9, 'person-vehicle-detection': 7 } })
    }
  };

  function onReady(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  }

  function normalise(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function slugify(value) {
    return normalise(value).replace(/\s+/g, '-');
  }

  function canonicalNeedSlug(slug) {
    var canonical = slugify(slug || '');
    var api = window.saCollectionSelectorIndustryApi;
    if (api && api.canonicalCommonNeedSlug) canonical = api.canonicalCommonNeedSlug(canonical);
    return COMMON_NEED_ALIASES[canonical] || canonical;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseProducts(root) {
    var node = root.querySelector('[data-sa-industry-products]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]').map(function (product, index) {
        product._saIndex = index;
        return product;
      });
    } catch (error) {
      return [];
    }
  }

  function toArray(value) {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  }

  function productTags(product) {
    var tags = toArray(product.tags).map(function (tag) { return String(tag || ''); }).filter(Boolean);
    if (!tags.length && product.matchText) tags = String(product.matchText).match(/sa_[a-z0-9_-]+/gi) || [];
    return tags;
  }

  function taxonomyValues(tags, prefix) {
    return tags.map(function (tag) {
      var lower = String(tag || '').toLowerCase();
      return lower.indexOf(prefix) === 0 ? slugify(lower.slice(prefix.length)) : '';
    }).filter(Boolean);
  }

  function detectBrand(product, tags) {
    var tagText = normalise(tags.join(' '));
    var titleText = normalise(product.title || '');
    var fallbackText = normalise([product.url, product.matchText].join(' '));
    var best = null;
    BRAND_DEFINITIONS.some(function (brand) {
      var foundInTitle = brand.terms.some(function (term) { return titleText.indexOf(normalise(term)) !== -1; });
      if (foundInTitle) {
        best = { key: brand.key, label: brand.label, source: 'title' };
        return true;
      }
      var foundInTags = brand.terms.some(function (term) { return tagText.indexOf(normalise(term)) !== -1; });
      if (foundInTags) {
        best = { key: brand.key, label: brand.label, source: 'tag' };
        return true;
      }
      var foundInFallback = brand.terms.some(function (term) { return fallbackText.indexOf(normalise(term)) !== -1; });
      if (foundInFallback) {
        best = { key: brand.key, label: brand.label, source: 'matchText' };
        return true;
      }
      return false;
    });
    return best || { key: '', label: '', source: '' };
  }

  function roleFamily(roles, product) {
    var title = normalise(product.title || '');
    var intercomPrimary = /(intercom kit|video intercom kit|door station|outdoor station|video door phone|ip intercom|2mp intercom)/.test(title);
    var intercomComponent = /(bracket|housing|rain cover|power supply|tenant station|master station|room station|indoor monitor|handset|expansion station|keypad module|display module|name scroll module|flush mount for|surface mount for)/.test(title) && !/(intercom kit|video intercom kit|door station|outdoor station|video door phone)/.test(title);
    var cctvKit = roles.indexOf('complete-kit') !== -1
      || /(cctv kit|camera kit|nvr cctv kit|nvr kit|security kit|camera package|cctv package|package|bundle)/.test(title)
      || (title.indexOf(' kit ') !== -1 && /(camera|cameras|channel|channels|nvr|dvr|poe)/.test(title));
    if (intercomComponent) return 'accessory';
    if (roles.indexOf('intercom-kit') !== -1 || intercomPrimary || (title.indexOf(' intercom ') !== -1 && !intercomComponent)) return 'intercom-kit';
    if (cctvKit) return 'complete-kit';
    if (roles.indexOf('ptz-camera') !== -1) return 'ptz-camera';
    if (roles.indexOf('bullet-camera') !== -1) return 'bullet-camera';
    if (roles.indexOf('turret-camera') !== -1) return 'turret-camera';
    if (roles.indexOf('dome-camera') !== -1) return 'dome-camera';
    if (title.indexOf('ptz') !== -1) return 'ptz-camera';
    if (title.indexOf('bullet') !== -1) return 'bullet-camera';
    if (title.indexOf('turret') !== -1 || title.indexOf('eyeball') !== -1) return 'turret-camera';
    if (title.indexOf('dome') !== -1) return 'dome-camera';
    if (roles.indexOf('camera') !== -1) return 'camera';
    return 'camera';
  }

  function resolutionMp(product) {
    var text = toArray(product.resolution).map(function (item) {
      if (typeof item === 'string') return item;
      if (item && typeof item === 'object') return item.resolution || item.label || item.value || '';
      return '';
    }).join(' ');
    var match = text.match(/(\d+(?:\.\d+)?)\s*mp/i);
    if (match) return Number(match[1]);
    if (/4k/i.test(text)) return 8;
    return 0;
  }

  function productFacts(product) {
    if (product._saFacts) return product._saFacts;
    var tags = productTags(product);
    var roles = taxonomyValues(tags, 'sa_role_');
    var manifestBrand = slugify(product.brand || product.brandKey || '');
    var brand = manifestBrand ? {
      key: manifestBrand,
      label: product.brandLabel || brandLabelForKey(manifestBrand),
      source: 'manifest'
    } : detectBrand(product, tags);
    product._saFacts = {
      tags: tags,
      roles: roles,
      areas: taxonomyValues(tags, 'sa_area_'),
      concerns: taxonomyValues(tags, 'sa_concern_'),
      industries: taxonomyValues(tags, 'sa_industry_'),
      brandKey: brand.key,
      brandLabel: brand.label,
      brandSource: brand.source,
      family: roleFamily(roles, product),
      resolutionMp: resolutionMp(product)
    };
    return product._saFacts;
  }

  function hasCommonNeedMapping(product, slug) {
    var mappedText = normalise(product.commonNeedText || '');
    if (!mappedText) return false;
    var needText = normalise(slug).replace(/\s+/g, ' ');
    return mappedText.indexOf(needText) !== -1 || mappedText.replace(/\s+/g, '-').indexOf(slug) !== -1;
  }

  function eligibilityFailure(product, facts, profileSettings, industryTag) {
    var titleText = normalise(product.title || '');
    if (!product.available) return 'unavailable';
    if (product.manualReviewRequired === true || String(product.manualReviewRequired) === 'true') return 'manual-review';
    if (normalise(product.merchandisingEligibility || '') && normalise(product.merchandisingEligibility || '') !== 'primary') return 'not-primary';
    if (facts.family === 'accessory') return 'excluded-role';
    if (facts.industries.length && facts.industries.indexOf(industryTag) === -1 && !profileSettings.allowCrossIndustry) return 'industry-mismatch';
    if (!profileSettings.allowIntercom && facts.family === 'intercom-kit') return 'intercom-mismatch';
    if ((titleText.indexOf('recorder') !== -1 || titleText.indexOf(' nvr') !== -1) && facts.family !== 'complete-kit' && titleText.indexOf('kit') === -1) return 'recorder';
    if ((profileSettings.blockedFamilies || {})[facts.family]) return 'blocked-family';
    if (facts.roles.some(function (role) { return BASE_EXCLUDED_ROLES[role]; })) return 'excluded-role';
    return '';
  }

  function addWeighted(scoreState, group, key, weight) {
    if (!weight) return;
    scoreState.score += weight;
    if (weight > 0) {
      var reasonKey = group + ':' + key;
      scoreState.reasons.push({ key: reasonKey, label: REASON_LABELS[reasonKey] || key.split('-').join(' '), weight: weight });
    }
  }

  function priceAmount(value) {
    if (typeof value === 'number') return value;
    var match = String(value || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : 0;
  }

  function isHighPrice(product, profileSettings) {
    var limit = (profileSettings.commercial || {}).highPriceLimit || 0;
    return Boolean(limit && priceAmount(product.price) > limit);
  }

  function applyCommercialScore(state, product, facts, profileSettings, needSlug) {
    var commercial = profileSettings.commercial || {};
    var price = priceAmount(product.price);
    if (commercial.imageWeight && product.image) addWeighted(state, 'commercial', 'product-image-available', commercial.imageWeight);
    if (!product.image && commercial.missingImagePenalty) state.score -= commercial.missingImagePenalty;
    if (commercial.mainstreamBrandWeight && MAINSTREAM_BRANDS[facts.brandKey]) addWeighted(state, 'commercial', 'mainstream-commercial-fit', commercial.mainstreamBrandWeight);
    if (commercial.valuePriceCeiling && price && price <= commercial.valuePriceCeiling) addWeighted(state, 'commercial', 'value-price-fit', commercial.valueReward || 0);
    if (commercial.completeSystemReward && facts.family === 'complete-kit') addWeighted(state, 'commercial', 'complete-cctv-kit', commercial.completeSystemReward);
    if (needSlug === 'visitor-management' || needSlug === 'visitor-access' || needSlug === 'intercom-communication' || needSlug === 'two-way-talk-and-intercom' || needSlug === 'apartment-or-gated-access') {
      addWeighted(state, 'commercial', 'purpose-built-visitor-access', facts.family === 'intercom-kit' ? 10 : 0);
    }
    if (needSlug === 'pickup-drop-off-areas' && (facts.family === 'complete-kit' || facts.family === 'turret-camera' || facts.family === 'bullet-camera')) {
      addWeighted(state, 'commercial', 'vehicle-flow-coverage', 8);
    }
    if (commercial.allowPremium === false && PREMIUM_BRANDS[facts.brandKey]) state.score -= commercial.premiumPenalty || 0;
    if (commercial.highPriceLimit && price > commercial.highPriceLimit) state.score -= commercial.highPricePenalty || 0;
    if (commercial.ptzSpecialistPenalty && facts.family === 'ptz-camera') state.score -= commercial.ptzSpecialistPenalty;
  }

  function scoreProduct(product, profileSettings, industryHandle, needSlug) {
    var facts = productFacts(product);
    var industryTag = INDUSTRY_TAG_BY_HANDLE[industryHandle] || slugify(industryHandle);
    var failure = eligibilityFailure(product, facts, profileSettings, industryTag);
    if (failure) return { product: product, score: -999, failure: failure, reasons: [], confidence: 'LOW' };

    var state = { score: 0, reasons: [] };
    if (hasCommonNeedMapping(product, needSlug)) state.score += 20;
    if (facts.industries.indexOf(industryTag) !== -1) state.score += 10;
    if (!facts.industries.length) state.score += 2;
    state.score += Math.max(0, 6 - Number(product._saIndex || 0) * 0.08);
    state.score += Number(product.priority || 0) || 0;
    state.score += product.available ? 4 : 0;

    addWeighted(state, 'role', facts.family, (profileSettings.families || {})[facts.family] || 0);
    Object.keys(profileSettings.areas || {}).forEach(function (area) {
      if (facts.areas.indexOf(area) !== -1) addWeighted(state, 'area', area, profileSettings.areas[area]);
    });
    Object.keys(profileSettings.concerns || {}).forEach(function (concern) {
      if (facts.concerns.indexOf(concern) !== -1) addWeighted(state, 'concern', concern, profileSettings.concerns[concern]);
    });
    Object.keys(profileSettings.negativeRoles || {}).forEach(function (role) {
      if (facts.family === role || facts.roles.indexOf(role) !== -1) state.score += profileSettings.negativeRoles[role];
    });
    if (facts.resolutionMp >= 8) addWeighted(state, 'resolution', 'high', profileSettings.highResolutionWeight || 6);
    else if (facts.resolutionMp >= 4) state.score += profileSettings.mediumResolutionWeight || 3;
    applyCommercialScore(state, product, facts, profileSettings, needSlug);

    var confidence = state.score >= (profileSettings.strongThreshold || 62) && state.reasons.length >= 2 ? 'HIGH' : (state.score >= (profileSettings.threshold || 34) ? 'MEDIUM' : 'LOW');
    return {
      product: product,
      score: state.score,
      failure: '',
      reasons: state.reasons.sort(function (a, b) { return b.weight - a.weight; }),
      confidence: confidence
    };
  }

  function profileFor(industryHandle, slug) {
    var industryProfiles = INDUSTRY_NEED_PROFILES[industryHandle] || {};
    var canonical = canonicalNeedSlug(slug);
    return Object.assign({}, GENERIC_PROFILE, industryProfiles[slug] || industryProfiles[canonical] || {});
  }

  function diversify(scored, max, brandKey, profileSettings) {
    var limit = max || 8;
    var maxBrandInFirstFour = brandKey ? 99 : ((profileSettings.diversity || {}).maxBrandInFirstFour || 2);
    var commercial = profileSettings.commercial || {};
    var topFourTarget = Math.min(4, limit, scored.length);
    var firstFourFamily = commercial.firstFourFamily || '';
    var firstFourFamilies = commercial.firstFourFamilies || [];
    var requiredFamilyCount = firstFourFamily ? scored.filter(function (item) { return productFacts(item.product).family === firstFourFamily; }).length : 0;
    var preferredFamilyCount = firstFourFamilies.length ? scored.filter(function (item) { return firstFourFamilies.indexOf(productFacts(item.product).family) !== -1; }).length : 0;
    var imageCount = scored.filter(function (item) { return Boolean(item.product.image); }).length;
    var nonPremiumCount = scored.filter(function (item) { return !PREMIUM_BRANDS[productFacts(item.product).brandKey]; }).length;
    var fairPriceCount = scored.filter(function (item) { return !isHighPrice(item.product, profileSettings); }).length;
    var picked = [];
    var skipped = [];
    var brandCounts = {};
    var premiumFirstFour = 0;
    var highPriceFirstFour = 0;

    scored.forEach(function (item) {
      if (picked.length >= limit) return;
      var brand = productFacts(item.product).brandKey || 'unknown';
      var facts = productFacts(item.product);
      if (picked.length < topFourTarget) {
        if (firstFourFamily && requiredFamilyCount >= topFourTarget && facts.family !== firstFourFamily) {
          skipped.push(item);
          return;
        }
        if (firstFourFamilies.length && preferredFamilyCount >= topFourTarget && firstFourFamilies.indexOf(facts.family) === -1) {
          skipped.push(item);
          return;
        }
        if (commercial.preferImageTopFour !== false && imageCount >= topFourTarget && !item.product.image) {
          skipped.push(item);
          return;
        }
        if (typeof commercial.maxPremiumInFirstFour === 'number' && PREMIUM_BRANDS[brand] && premiumFirstFour >= commercial.maxPremiumInFirstFour && nonPremiumCount >= topFourTarget) {
          skipped.push(item);
          return;
        }
        if (typeof commercial.maxHighPriceInFirstFour === 'number' && isHighPrice(item.product, profileSettings) && highPriceFirstFour >= commercial.maxHighPriceInFirstFour && fairPriceCount >= topFourTarget) {
          skipped.push(item);
          return;
        }
      }
      if (picked.length < 4 && brandCounts[brand] >= maxBrandInFirstFour) {
        skipped.push(item);
        return;
      }
      picked.push(item);
      if (picked.length <= topFourTarget && PREMIUM_BRANDS[brand]) premiumFirstFour += 1;
      if (picked.length <= topFourTarget && isHighPrice(item.product, profileSettings)) highPriceFirstFour += 1;
      brandCounts[brand] = (brandCounts[brand] || 0) + 1;
    });

    skipped.concat(scored).forEach(function (item) {
      if (picked.length >= limit || picked.indexOf(item) !== -1) return;
      picked.push(item);
    });
    return picked.slice(0, limit);
  }

  function recommend(products, industryHandle, needSlug, options) {
    var settings = options || {};
    var profileSettings = profileFor(industryHandle, needSlug);
    var threshold = profileSettings.threshold || 34;
    var brandKey = settings.brandKey || '';
    var scoredAll = products.map(function (product) {
      return scoreProduct(product, profileSettings, industryHandle, needSlug);
    });
    var scored = scoredAll.filter(function (item) {
      if (item.failure || item.score < threshold) return false;
      return !brandKey || productFacts(item.product).brandKey === brandKey;
    }).sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return Number(a.product._saIndex || 0) - Number(b.product._saIndex || 0);
    });
    var selected = diversify(scored, settings.max || 8, brandKey, profileSettings);
    var productsOut = selected.map(function (item, index) {
      return Object.assign({}, item.product, {
        _saScore: item.score,
        _saReasons: item.reasons.slice(0, 3).map(function (reason) { return reason.label; }),
        _saConfidence: item.confidence,
        _saBestMatch: index === 0 && item.confidence === 'HIGH'
      });
    });
    return {
      profile: profileSettings,
      candidateCount: products.length,
      eligibleCount: scored.length,
      scoredCount: scoredAll.filter(function (item) { return !item.failure && item.score >= threshold; }).length,
      displayedCount: productsOut.length,
      matchType: brandKey ? 'profile-brand' : 'profile',
      confidence: productsOut.some(function (product) { return product._saConfidence === 'HIGH'; }) ? 'HIGH' : (productsOut.length ? 'MEDIUM' : 'LOW'),
      products: productsOut
    };
  }

  function recommendCached(root, products, industryHandle, needSlug, options) {
    root._saIndustryRecommendationCache = root._saIndustryRecommendationCache || {};
    var settings = options || {};
    var key = [
      industryHandle,
      canonicalNeedSlug(needSlug),
      settings.brandKey || '',
      settings.max || 8,
      products.length
    ].join('|');
    if (!root._saIndustryRecommendationCache[key]) {
      root._saIndustryRecommendationCache[key] = recommend(products, industryHandle, needSlug, settings);
    }
    return root._saIndustryRecommendationCache[key];
  }

  function handleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function brandLabelForKey(key) {
    var match = BRAND_DEFINITIONS.find(function (brand) { return brand.key === key; });
    return match ? match.label : key;
  }

  function titleCaseReason(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().replace(/\b\w/g, function (letter) {
      return letter.toUpperCase();
    }).replace(/\bIr\b/g, 'IR').replace(/\bWdr\b/g, 'WDR').replace(/\bPtz\b/g, 'PTZ').replace(/\bAnpr\b/g, 'ANPR').replace(/\bLpr\b/g, 'LPR');
  }

  function addReason(reasons, seen, label) {
    var clean = COMPACT_REASON_LABELS[String(label || '').replace(/\s+/g, ' ').trim()] || String(label || '').replace(/\s+/g, ' ').trim();
    var key = normalise(clean);
    if (!clean || seen[key] || GENERIC_REASON_TERMS.test(clean)) return;
    seen[key] = true;
    reasons.push(clean);
  }

  function productReasonLabels(product) {
    var facts = productFacts(product);
    var reasons = [];
    var seen = {};
    var badges = toArray(product.badges).map(function (badge) { return String(badge || '').trim(); }).filter(Boolean);
    var sourceText = [
      product.title,
      product.sku,
      badges.join(' '),
      product.lensType,
      product.nightVision,
      product.cameraFormFactor,
      product.matchText
    ].join(' ');
    var lower = normalise(sourceText);
    var zoomMatch = sourceText.match(/\b(\d{2,3})\s*x(?:\s*(?:optical\s*)?zoom)?\b/i);
    var irMatch = sourceText.match(/\b(\d{2,3})\s*m\s*(?:ir|infrared)\b/i);

    badges.forEach(function (badge) {
      var badgeText = normalise(badge);
      if (/(zoom|ir|varifocal|deterrence|vehicle|tracking|colour night|color night|wdr|outdoor|ip6|ptz|anpr|lpr)/.test(badgeText)) {
        addReason(reasons, seen, titleCaseReason(badge));
      }
    });
    if (zoomMatch) addReason(reasons, seen, zoomMatch[1] + 'x Zoom');
    if (irMatch) addReason(reasons, seen, irMatch[1] + 'm IR');
    if (lower.indexOf('motorised varifocal') !== -1 || lower.indexOf('motorized varifocal') !== -1) addReason(reasons, seen, 'Motorised varifocal');
    else if (lower.indexOf('varifocal') !== -1) addReason(reasons, seen, 'Varifocal lens');
    if (lower.indexOf('ai tracking') !== -1 || lower.indexOf('auto tracking') !== -1) addReason(reasons, seen, 'AI tracking');
    if (lower.indexOf('vehicle detection') !== -1) addReason(reasons, seen, 'Vehicle detection');
    if (lower.indexOf('person vehicle detection') !== -1 || lower.indexOf('person and vehicle') !== -1) addReason(reasons, seen, 'Person/vehicle detection');
    if (lower.indexOf('active deterrence') !== -1) addReason(reasons, seen, 'Active deterrence');
    if (lower.indexOf('colour night') !== -1 || lower.indexOf('color night') !== -1) addReason(reasons, seen, 'Colour night vision');
    if (lower.indexOf(' wdr ') !== -1 || lower.indexOf('wide dynamic range') !== -1) addReason(reasons, seen, 'WDR');
    if (lower.indexOf('outdoor') !== -1 || lower.indexOf('ip66') !== -1 || lower.indexOf('ip67') !== -1) addReason(reasons, seen, 'Outdoor rated');
    if (facts.family === 'ptz-camera') addReason(reasons, seen, 'PTZ coverage');
    if (facts.resolutionMp >= 8) addReason(reasons, seen, '8MP clarity');
    if (lower.indexOf('anpr') !== -1 || lower.indexOf(' lpr ') !== -1 || lower.indexOf('license plate') !== -1 || lower.indexOf('licence plate') !== -1) addReason(reasons, seen, 'ANPR/LPR');

    toArray(product._saReasons).forEach(function (reason) {
      addReason(reasons, seen, reason);
    });
    return reasons;
  }

  function productCard(product) {
    var facts = productFacts(product);
    var handle = handleFromUrl(product.url);
    var image = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.imageAlt || product.title) + '" loading="lazy">'
      : '<span class="sa-industry-common-needs__product-placeholder" aria-hidden="true">Image coming soon</span>';
    var price = moneyText(product.price);
    var compare = product.compareAtPrice ? '<s>' + escapeHtml(moneyText(product.compareAtPrice)) + '</s>' : '';
    var sku = product.sku ? '<p class="sa-industry-common-needs__product-sku">' + escapeHtml(product.sku) + '</p>' : '';
    var brand = facts.brandLabel ? '<p class="sa-industry-common-needs__product-meta">' + escapeHtml(facts.brandLabel) + '</p>' : '';
    var reasonLabels = productReasonLabels(product);
    var hiddenReasonCount = Math.max(0, reasonLabels.length - 2);
    var reasons = reasonLabels.slice(0, 2).map(function (reason) {
      return '<span>' + escapeHtml(reason) + '</span>';
    }).join('');
    if (hiddenReasonCount) reasons += '<span class="sa-industry-common-needs__fit-more">+' + hiddenReasonCount + '</span>';
    var reasonBlock = reasons ? '<div class="sa-industry-common-needs__fit"><strong>Why it fits</strong><span>' + reasons + '</span></div>' : '';
    var best = product._saBestMatch ? '<span class="sa-industry-common-needs__badge-best">Best match</span>' : '';
    var sale = product.compareAtPrice ? '<span class="sa-industry-common-needs__badge-sale">Sale</span>' : '';
    var primaryAction = '';
    if (product.available && product.hasOnlyDefaultVariant && product.variantId) {
      primaryAction = '<form method="post" action="/cart/add" class="sa-industry-common-needs__cart"><input type="hidden" name="id" value="' + escapeHtml(product.variantId) + '"><input type="hidden" name="quantity" value="1"><button type="submit">Add to Cart</button></form>';
    } else if (product.available) {
      primaryAction = '<a class="sa-industry-common-needs__primary-link" href="' + escapeHtml(product.url) + '">Choose Options</a>';
    } else {
      primaryAction = '<span class="sa-industry-common-needs__sold-out">Sold out</span>';
    }
    return [
      '<article class="sa-industry-common-needs__product" data-product-handle="' + escapeHtml(handle) + '" data-brand="' + escapeHtml(facts.brandKey) + '">',
      '  <div class="sa-industry-common-needs__product-badges">' + best + sale + '</div>',
      '  <a class="sa-industry-common-needs__product-image" href="' + escapeHtml(product.url) + '">' + image + '</a>',
      '  <div class="sa-industry-common-needs__product-body">',
      brand,
      '    <a class="sa-industry-common-needs__product-title" href="' + escapeHtml(product.url) + '" title="' + escapeHtml(product.title) + '">' + escapeHtml(product.title) + '</a>',
      sku,
      reasonBlock,
      price ? '    <div class="sa-industry-common-needs__price">' + escapeHtml(price) + compare + '</div>' : '',
      '    <div class="sa-industry-common-needs__product-actions">' + primaryAction + '<a class="sa-industry-common-needs__product-link" href="' + escapeHtml(product.url) + '">View Details</a></div>',
      '  </div>',
      '</article>'
    ].join('');
  }

  function fallbackHtml(message, activeBrandLabel) {
    var title = activeBrandLabel ? 'No strong ' + activeBrandLabel + ' match for this requirement.' : 'Recommendations coming soon';
    var allBrands = activeBrandLabel ? '<button type="button" data-sa-view-all-brands>View all brands</button>' : '';
    return '<div class="sa-industry-common-needs__fallback"><strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(message || 'Use the selector below or ask our team for advice for this requirement.') + '</span>' + allBrands + '<a href="/pages/contact-page">Get expert advice</a></div>';
  }

  function destinationManifest(root) {
    var payload = window.SecurityAustraliaDestinationRecommendations || {};
    var destinations = payload.destinations || {};
    return destinations[root.getAttribute('data-collection-handle') || ''] || null;
  }

  function destinationNeedSlug(manifest, slug) {
    var raw = slugify(slug || '');
    if (!raw) return '';
    if (manifest && manifest.needs && manifest.needs[raw]) return raw;
    var canonical = canonicalNeedSlug(raw);
    if (manifest && manifest.needs && manifest.needs[canonical]) return canonical;
    return raw;
  }

  function selectedNeedFromUrl(manifest) {
    return destinationNeedSlug(manifest, selectedNeedParamFromUrl());
  }

  function selectedNeedParamFromUrl() {
    return slugify(new URLSearchParams(window.location.search).get('sa_need') || '');
  }

  function brandFromUrl() {
    return slugify(new URLSearchParams(window.location.search).get('sa_brand') || '');
  }

  function presetFor(root, slug) {
    var manifest = destinationManifest(root);
    if (!manifest) return null;
    var needSlug = destinationNeedSlug(manifest, slug);
    if (needSlug && manifest.needs && manifest.needs[needSlug]) return manifest.needs[needSlug];
    return manifest.default || null;
  }

  function manifestNeed(manifest, slug) {
    var needSlug = destinationNeedSlug(manifest, slug);
    return ((manifest && manifest.commonNeeds) || []).filter(function (need) {
      return need.slug === needSlug;
    })[0] || null;
  }

  function moneyText(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'string') return value;
    var amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    return '$' + amount.toLocaleString('en-AU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function handleKey(handle) {
    return String(handle || '').replace(/^\/products\//, '').replace(/[?#].*$/, '');
  }

  function productJsonPath(handle) {
    var safeHandle = handleKey(handle).toLowerCase().replace(/[^a-z0-9-]/g, '');
    return safeHandle ? '/products/' + safeHandle + '.js' : '';
  }

  function buildProductLookup(products) {
    var lookup = { byId: {}, byHandle: {} };
    products.forEach(function (product) {
      var id = String(product.id || '');
      var handle = handleFromUrl(product.url) || product.handle || '';
      if (id) lookup.byId[id] = product;
      if (handle) lookup.byHandle[handleKey(handle)] = product;
    });
    return lookup;
  }

  function mergeManifestProduct(root, entry, index, fetchedProduct) {
    var lookup = root._saProductLookup || { byId: {}, byHandle: {} };
    var local = lookup.byId[String(entry.id || '')] || lookup.byHandle[handleKey(entry.handle)] || null;
    var product = Object.assign({}, local || {}, fetchedProduct || {}, {
      id: entry.id || (local && local.id) || (fetchedProduct && fetchedProduct.id),
      title: entry.title || (local && local.title) || (fetchedProduct && fetchedProduct.title),
      url: entry.url || (local && local.url) || ('/products/' + handleKey(entry.handle)),
      vendor: entry.vendor || (local && local.vendor) || (fetchedProduct && fetchedProduct.vendor),
      brand: entry.brand || (local && local.brand) || '',
      brandLabel: entry.brandLabel || (local && local.brandLabel) || brandLabelForKey(entry.brand || ''),
      productRole: entry.productRole || (local && local.productRole) || '',
      available: fetchedProduct && Object.prototype.hasOwnProperty.call(fetchedProduct, 'available') ? fetchedProduct.available : (local && Object.prototype.hasOwnProperty.call(local, 'available') ? local.available : true),
      price: local && local.price ? local.price : ((fetchedProduct && fetchedProduct.price) || moneyText(entry.price)),
      compareAtPrice: local && local.compareAtPrice ? local.compareAtPrice : ((fetchedProduct && fetchedProduct.compareAtPrice) || moneyText(entry.compareAtPrice)),
      image: (local && local.image) || (fetchedProduct && fetchedProduct.image) || entry.image || '',
      imageAlt: (local && local.imageAlt) || (fetchedProduct && fetchedProduct.imageAlt) || entry.imageAlt || entry.title || '',
      _saReasons: entry.reasons || [],
      _saConfidence: entry.confidence || '',
      _saBestMatch: index === 0 && entry.confidence === 'HIGH',
      _saScore: entry.score || 0
    });
    if (!product.handle) product.handle = handleFromUrl(product.url) || entry.handle || '';
    return product;
  }

  function productFromShopifyJson(handle, json) {
    var variants = Array.isArray(json.variants) ? json.variants : [];
    var variant = variants.filter(function (candidate) { return candidate.available; })[0] || variants[0] || {};
    var image = json.featured_image || (Array.isArray(json.images) ? json.images[0] : null);
    if (image && typeof image === 'object') image = image.src || image.url || null;
    var compare = variant.compare_at_price || json.compare_at_price || null;
    var price = variant.price || json.price || null;
    return {
      id: json.id,
      variantId: variant.id,
      title: json.title,
      url: '/products/' + (json.handle || handle),
      handle: json.handle || handle,
      sku: variant.sku || '',
      vendor: json.vendor || '',
      tags: json.tags || [],
      available: json.available !== false && variant.available !== false,
      hasOnlyDefaultVariant: variants.length === 1 && (!variant.title || variant.title === 'Default Title'),
      price: moneyText(Number(price || 0) / 100),
      compareAtPrice: compare && Number(compare) > Number(price || 0) ? moneyText(Number(compare) / 100) : '',
      image: image,
      imageAlt: json.title || ''
    };
  }

  function fetchManifestProduct(root, entry, index) {
    var lookup = root._saProductLookup || { byId: {}, byHandle: {} };
    var local = lookup.byId[String(entry.id || '')] || lookup.byHandle[handleKey(entry.handle)] || null;
    if (local && local.image) return Promise.resolve(mergeManifestProduct(root, entry, index));

    root._saFetchedProducts = root._saFetchedProducts || {};
    var handle = handleKey(entry.handle || handleFromUrl(entry.url));
    var jsonPath = productJsonPath(handle);
    if (!jsonPath) return Promise.resolve(mergeManifestProduct(root, entry, index));
    if (!root._saFetchedProducts[handle]) {
      root._saFetchedProducts[handle] = fetch(jsonPath, {
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) throw new Error('Product JSON unavailable');
        return response.json();
      }).then(function (json) {
        return productFromShopifyJson(handle, json);
      }).catch(function () {
        return null;
      });
    }
    return root._saFetchedProducts[handle].then(function (fetchedProduct) {
      return mergeManifestProduct(root, entry, index, fetchedProduct);
    });
  }

  function filteredPresetEntries(preset, brandKey, maxProducts) {
    var entries = Array.isArray(preset && preset.rankedProducts) ? preset.rankedProducts.slice() : [];
    if (brandKey) {
      entries = entries.filter(function (entry) {
        var key = slugify(entry.brand || '');
        return key === brandKey;
      });
    }
    return entries.slice(0, maxProducts || 8);
  }

  function setActiveChip(root, slug) {
    var manifest = destinationManifest(root);
    var activeSlug = destinationNeedSlug(manifest, slug);
    Array.prototype.slice.call(root.querySelectorAll('[data-sa-common-need-chip]')).forEach(function (chip) {
      var chipSlug = destinationNeedSlug(manifest, chip.getAttribute('data-need-slug') || '');
      var active = Boolean(activeSlug) && chipSlug === activeSlug;
      chip.classList.toggle('is-active', active);
      if (active) chip.setAttribute('aria-current', 'true');
      else chip.removeAttribute('aria-current');
    });
  }

  function syncControls(row) {
    var track = row.querySelector('[data-sa-need-products]');
    var prev = row.querySelector('[data-sa-need-prev]');
    var next = row.querySelector('[data-sa-need-next]');
    if (!track || !prev || !next) return;
    var canScroll = track.scrollWidth > track.clientWidth + 4;
    prev.hidden = !canScroll;
    next.hidden = !canScroll;
    if (!canScroll) return;
    prev.disabled = track.scrollLeft <= 4;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    prev.setAttribute('aria-disabled', String(prev.disabled));
    next.setAttribute('aria-disabled', String(next.disabled));
  }

  function initCarousel(row) {
    var track = row.querySelector('[data-sa-need-products]');
    var prev = row.querySelector('[data-sa-need-prev]');
    var next = row.querySelector('[data-sa-need-next]');
    if (!track || !prev || !next || row.dataset.saNeedCarouselReady === 'true') return;
    row.dataset.saNeedCarouselReady = 'true';
    var amount = function () {
      var card = track.querySelector('.sa-industry-common-needs__product');
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card ? Math.max(230, Math.round(card.getBoundingClientRect().width + gap)) : Math.max(260, Math.round(track.clientWidth * 0.66));
    };
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -amount(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: amount(), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
    track.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      track.scrollBy({ left: event.key === 'ArrowRight' ? amount() : -amount(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () { syncControls(row); }, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(function () { syncControls(row); }).observe(track);
    window.setTimeout(function () { syncControls(row); }, 80);
  }

  function collectBrandOptions(root) {
    var manifest = destinationManifest(root);
    var counts = {};
    var presets = [];
    if (manifest && manifest.default) presets.push(manifest.default);
    Object.keys((manifest && manifest.needs) || {}).forEach(function (slug) {
      presets.push(manifest.needs[slug]);
    });
    presets.forEach(function (preset) {
      (preset.rankedProducts || []).forEach(function (entry) {
        var key = slugify(entry.brand || '');
        if (!key) return;
        counts[key] = counts[key] || { key: key, label: entry.brandLabel || brandLabelForKey(key), count: 0 };
        counts[key].count += 1;
      });
    });
    return Object.keys(counts).map(function (key) { return counts[key]; }).sort(function (a, b) {
      if (b.count !== a.count) return b.count - a.count;
      return a.label.localeCompare(b.label);
    });
  }

  function populateBrandControl(root, activeBrand) {
    var tool = root.querySelector('[data-sa-brand-tool]');
    var select = root.querySelector('[data-sa-brand-select]');
    if (!tool || !select) return '';
    var brands = collectBrandOptions(root);
    if (!brands.length) {
      tool.hidden = true;
      return '';
    }
    select.innerHTML = '<option value="">All brands</option>' + brands.map(function (brand) {
      return '<option value="' + escapeHtml(brand.key) + '">' + escapeHtml(brand.label) + '</option>';
    }).join('');
    activeBrand = brands.some(function (brand) { return brand.key === activeBrand; }) ? activeBrand : '';
    select.value = activeBrand;
    tool.hidden = false;
    return activeBrand;
  }

  function updateUrlState(needSlug, brandKey, hash, replace) {
    var url = new URL(window.location.href);
    if (needSlug) url.searchParams.set('sa_need', needSlug);
    else url.searchParams.delete('sa_need');
    if (brandKey) url.searchParams.set('sa_brand', brandKey);
    else url.searchParams.delete('sa_brand');
    if (hash) url.hash = hash;
    var nextUrl = url.toString();
    if (replace) window.history.replaceState(null, '', nextUrl);
    else window.history.pushState(null, '', nextUrl);
  }

  function setStoredBrand(root, brandKey) {
    try {
      window.sessionStorage.setItem(BRAND_STORAGE_PREFIX + (root.getAttribute('data-collection-handle') || ''), brandKey || '');
    } catch (error) {}
  }

  function storedBrand(root) {
    try {
      return window.sessionStorage.getItem(BRAND_STORAGE_PREFIX + (root.getAttribute('data-collection-handle') || '')) || '';
    } catch (error) {
      return '';
    }
  }

  function setRowCopy(root, row, preset, activeSlug, options) {
    var manifest = destinationManifest(root) || {};
    var heading = row.querySelector('[data-sa-active-heading]');
    var description = row.querySelector('[data-sa-active-description]');
    var need = activeSlug ? manifestNeed(manifest, activeSlug) : null;
    var destinationLabel = root.getAttribute('data-destination-label') || manifest.title || 'this destination';
    if (heading) {
      heading.textContent = options && options.heading ? options.heading : (need ? need.label : (preset.label || ('Recommended for ' + destinationLabel)));
    }
    if (description) {
      description.textContent = options && options.description ? options.description : (need ? need.description : (preset.description || ('Selected because these products best match ' + destinationLabel + '.')));
    }
    row.setAttribute('data-need-row', activeSlug || '');
    row.setAttribute('data-need-label', need ? need.label : '');
  }

  function setRowLinks(root, row, activeSlug, brandKey, hasProducts) {
    var view = row.querySelector('[data-sa-need-view]');
    var refine = row.querySelector('[data-sa-refine-recommendations]');
    if (view) {
      var href = new URL(root.getAttribute('data-collection-url') || window.location.pathname, window.location.origin);
      var urlNeed = root._saUrlNeed || activeSlug;
      if (urlNeed) href.searchParams.set('sa_need', urlNeed);
      if (brandKey) href.searchParams.set('sa_brand', brandKey);
      href.hash = 'collection-products';
      view.href = href.pathname + href.search + href.hash;
      view.hidden = !hasProducts;
    }
    if (refine) refine.hidden = !activeSlug;
  }

  function renderPreset(root, activeSlug, options) {
    var settings = options || {};
    var row = root.querySelector('[data-sa-active-recommendation-row]');
    var track = row && row.querySelector('[data-sa-need-products]');
    var manifest = destinationManifest(root);
    var preset = settings.preset || presetFor(root, activeSlug);
    var maxProducts = Number(root.getAttribute('data-max-products') || 8);
    var brandKey = root._saActiveBrand || '';
    var renderToken = Date.now() + '-' + Math.random().toString(36).slice(2);
    if (!row || !track || !manifest || !preset) return;
    root._saRenderToken = renderToken;
    activeSlug = destinationNeedSlug(manifest, activeSlug);
    if (!preset.slug || preset.slug === 'default') activeSlug = '';
    if (!activeSlug) {
      root._saUrlNeed = '';
    } else if (settings.urlSlug) {
      root._saUrlNeed = slugify(settings.urlSlug);
    } else if (!root._saUrlNeed || destinationNeedSlug(manifest, root._saUrlNeed) !== activeSlug) {
      root._saUrlNeed = activeSlug;
    }
    root._saActiveNeed = activeSlug;
    setActiveChip(root, activeSlug);
    setRowCopy(root, row, preset, activeSlug, settings);

    var entries = filteredPresetEntries(preset, brandKey, maxProducts);
    var brandLabel = brandKey ? brandLabelForKey(brandKey) : '';
    row.setAttribute('data-candidate-count', String(preset.candidateCount || manifest.universeProductCount || 0));
    row.setAttribute('data-eligible-count', String(preset.eligibleCount || 0));
    row.setAttribute('data-displayed-count', '0');
    row.setAttribute('data-match-type', entries.length ? (brandKey ? 'canonical-brand' : 'canonical') : (brandKey ? 'no-brand-match' : 'none'));
    row.setAttribute('data-confidence', preset.confidence || '');
    track.innerHTML = '<div class="sa-industry-common-needs__fallback"><strong>Loading recommendations</strong><span>Checking current product details for this destination.</span></div>';
    track.classList.remove('is-populated');
    setRowLinks(root, row, activeSlug, brandKey, entries.length);

    Promise.all(entries.map(function (entry, index) {
      return fetchManifestProduct(root, entry, index);
    })).then(function (products) {
      if (root._saRenderToken !== renderToken) return;
      var visibleProducts = products.filter(Boolean);
      row.setAttribute('data-displayed-count', String(visibleProducts.length));
      if (visibleProducts.length) {
        track.innerHTML = visibleProducts.map(productCard).join('');
        track.classList.add('is-populated');
      } else {
        track.innerHTML = fallbackHtml('Switch back to all brands or ask our team for an equivalent option.', brandLabel);
        track.classList.remove('is-populated');
      }
      track.scrollLeft = 0;
      setRowLinks(root, row, activeSlug, brandKey, visibleProducts.length > 0);
      initCarousel(row);
      syncControls(row);
      window.dispatchEvent(new CustomEvent('sa:destination-recommendations-rendered', {
        detail: {
          collectionHandle: root.getAttribute('data-collection-handle') || '',
          need: activeSlug || 'default',
          brand: brandKey,
          productIds: visibleProducts.map(function (product) { return String(product.id || ''); }).filter(Boolean),
          productHandles: visibleProducts.map(function (product) { return handleFromUrl(product.url) || product.handle || ''; }).filter(Boolean)
        }
      }));
      if (settings.scroll) {
        window.setTimeout(function () {
          row.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        }, 0);
      }
    });
  }

  function activateNeed(root, slug, replace) {
    var manifest = destinationManifest(root);
    var requestedSlug = slugify(slug || '');
    var activeSlug = destinationNeedSlug(manifest, requestedSlug);
    root._saActiveNeed = activeSlug;
    root._saUrlNeed = activeSlug ? (requestedSlug || activeSlug) : '';
    updateUrlState(root._saUrlNeed, root._saActiveBrand || '', 'sa-destination-recommendations', replace);
    renderPreset(root, activeSlug, { urlSlug: root._saUrlNeed });
  }

  function selectorForDestination(root) {
    return document.querySelector('[data-sa-collection-selector][data-collection-handle="' + (root.getAttribute('data-collection-handle') || '') + '"]') || document.querySelector('[data-sa-collection-selector]');
  }

  function selectorIsOpen(selectorRoot) {
    return Boolean(selectorRoot && (
      selectorRoot.classList.contains('is-compact-open') ||
      selectorRoot.getAttribute('data-compact-open') === 'true'
    ));
  }

  function closeSelector(selectorRoot) {
    if (!selectorRoot) return false;
    if (window.saCollectionSelectorApi && typeof window.saCollectionSelectorApi.close === 'function') {
      return window.saCollectionSelectorApi.close({ root: selectorRoot });
    }
    selectorRoot.classList.remove('is-compact-open');
    selectorRoot.setAttribute('data-compact-open', 'false');
    return true;
  }

  function clearSelectorPersonalisation(root, settings) {
    var selectorRoot = selectorForDestination(root);
    if (!selectorRoot || !window.saCollectionSelectorApi || typeof window.saCollectionSelectorApi.clearPersonalisation !== 'function') return false;
    return window.saCollectionSelectorApi.clearPersonalisation(Object.assign({
      root: selectorRoot,
      collapse: true,
      resetAnswers: true,
      resetNative: false,
      preserveContext: true
    }, settings || {}));
  }

  function openSelector(root, mode, slug) {
    var selectorRoot = selectorForDestination(root);
    var settings = { scroll: true, focus: true, root: selectorRoot };
    if (root._saActiveBrand) settings.brand = root._saActiveBrand;
    var explicitSlug = arguments.length >= 3;
    var activeSlug = destinationNeedSlug(destinationManifest(root), explicitSlug ? (slug || '') : (slug || root._saActiveNeed || ''));
    if (!activeSlug && (mode || 'help') === 'help' && selectorIsOpen(selectorRoot)) {
      return closeSelector(selectorRoot);
    }
    var industryApi = window.saCollectionSelectorIndustryApi;
    if (activeSlug && industryApi && industryApi.applyCommonNeed) {
      return industryApi.applyCommonNeed(activeSlug, Object.assign({ submit: false, open: true }, settings));
    }
    if (window.saCollectionSelectorApi && window.saCollectionSelectorApi.open) {
      return window.saCollectionSelectorApi.open(mode || 'help', settings);
    }
    return false;
  }

  function selectorPreset(root, detail) {
    var manifest = destinationManifest(root);
    var basePreset = presetFor(root, root._saActiveNeed || selectedNeedFromUrl(manifest));
    if (!manifest || !basePreset) return null;
    var detailProducts = detail && Array.isArray(detail.products) ? detail.products : [];
    var wanted = {};
    detailProducts.forEach(function (product) {
      var id = String(product.id || '');
      var handle = handleFromUrl(product.url) || product.handle || '';
      if (id) wanted[id] = true;
      if (handle) wanted[handleKey(handle)] = true;
    });
    var entries = (basePreset.rankedProducts || []).filter(function (entry) {
      return wanted[String(entry.id || '')] || wanted[handleKey(entry.handle)];
    });
    if (!entries.length) entries = (basePreset.rankedProducts || []).slice();
    return Object.assign({}, basePreset, {
      label: 'Refined recommendations',
      description: detail && detail.note ? detail.note : 'Updated from your selector answers while keeping this destination as the product universe.',
      rankedProducts: entries,
      productCount: entries.length
    });
  }

  function initRoot(root) {
    if (root.dataset.saIndustryNeedsReady === 'true') return;
    root.dataset.saIndustryNeedsReady = 'true';
    var products = parseProducts(root);
    root._saProductLookup = buildProductLookup(products);
    var manifest = destinationManifest(root);
    if (!manifest) {
      root.hidden = true;
      return;
    }
    var activeBrand = brandFromUrl();
    var selectedNeedParam = selectedNeedParamFromUrl();
    var selectedNeed = selectedNeedFromUrl(manifest);
    root._saActiveBrand = populateBrandControl(root, activeBrand);
    setStoredBrand(root, root._saActiveBrand);
    root._saActiveNeed = selectedNeed;
    root._saUrlNeed = selectedNeed ? (selectedNeedParam || selectedNeed) : '';
    renderPreset(root, selectedNeed);

    root.addEventListener('change', function (event) {
      if (!event.target.matches('[data-sa-brand-select]')) return;
      root._saActiveBrand = event.target.value || '';
      setStoredBrand(root, root._saActiveBrand);
      updateUrlState(root._saUrlNeed || root._saActiveNeed || '', root._saActiveBrand, 'sa-destination-recommendations');
      renderPreset(root, root._saActiveNeed || '');
      if (window.saCollectionSelectorIndustryApi && window.saCollectionSelectorIndustryApi.setBrandPreference) {
        window.saCollectionSelectorIndustryApi.setBrandPreference(root._saActiveBrand);
      }
    });

    root.addEventListener('click', function (event) {
      var allBrands = event.target.closest && event.target.closest('[data-sa-view-all-brands]');
      if (allBrands) {
        event.preventDefault();
        root._saActiveBrand = '';
        setStoredBrand(root, '');
        var select = root.querySelector('[data-sa-brand-select]');
        if (select) select.value = '';
        updateUrlState(root._saUrlNeed || root._saActiveNeed || '', '', 'sa-destination-recommendations');
        renderPreset(root, root._saActiveNeed || '');
        return;
      }

      var selectorOpener = event.target.closest && event.target.closest('[data-sa-open-selector]');
      if (selectorOpener) {
        event.preventDefault();
        event.stopPropagation();
        openSelector(root, selectorOpener.getAttribute('data-sa-open-selector') || 'help', '');
        return;
      }

      var refine = event.target.closest && event.target.closest('[data-sa-refine-recommendations]');
      if (refine) {
        event.preventDefault();
        event.stopPropagation();
        openSelector(root, 'help', root._saActiveNeed || '');
        return;
      }

      var chip = event.target.closest && event.target.closest('[data-sa-common-need-chip]');
      if (chip) {
        event.preventDefault();
        event.stopPropagation();
        activateNeed(root, chip.getAttribute('data-need-slug') || '');
        clearSelectorPersonalisation(root);
        return;
      }

      var view = event.target.closest && event.target.closest('[data-sa-need-view]');
      if (!view) return;
      event.preventDefault();
      updateUrlState(root._saUrlNeed || root._saActiveNeed || '', root._saActiveBrand || '', 'collection-products');
      var target = document.getElementById('collection-products');
      if (target) {
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    });

    window.addEventListener('popstate', function () {
      var nextNeedParam = selectedNeedParamFromUrl();
      var nextNeed = selectedNeedFromUrl(destinationManifest(root));
      var nextBrand = brandFromUrl();
      root._saActiveNeed = nextNeed;
      root._saUrlNeed = nextNeed ? (nextNeedParam || nextNeed) : '';
      root._saActiveBrand = populateBrandControl(root, nextBrand);
      renderPreset(root, nextNeed);
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR)).forEach(initRoot);
  }

  onReady(initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
